import useSWRMutation from 'swr/mutation';
import {mutate} from 'swr';

import CSS from './MarkAsReadButton.module.scss';
import Vector from '@/components/elements/vector/Vector';
import {
  NotificationsRoutes,
  setReadNotification,
  setReadAllNotifications
} from '@/lib/fetch/notifications';
import type {Notification} from '@/types/api/notifications';

export default function MarkAsReadButton({
  id,
  setAsSeen,
  isReadAll,
  isReadAllSystem
}: {
  id?: Notification['_id'];
  setAsSeen?: (id: Notification['_id']) => void;
  isReadAll?: boolean;
  isReadAllSystem?: boolean;
}) {
  const query = {isSystem: isReadAllSystem};
  const {data, isMutating, error, trigger} = useSWRMutation(
    isReadAll ? [NotificationsRoutes.ReadAll, query] : NotificationsRoutes.Read,
    (url: any, {arg}: {arg: Parameters<typeof setReadNotification>[0]}) =>
      isReadAll
        ? setReadAllNotifications(undefined, query)
        : setReadNotification(arg, {id: id!}),
    {onSuccess}
  );

  function onSuccess() {
    mutate(NotificationsRoutes.Unread);
    if (!isReadAll) {
      setAsSeen!(id!);
    }
  }

  /**
   * Because the <SVG> elements would be changed on click, the
   * `useClickOut()` hook on the parent component cannot detect
   * the clicked element as child because the element is not part
   * of the DOM anymore.
   *
   * Therefore, the click handler should be placed on a wrapper
   * element and clicks on the <SVG> elements should be ignored.
   *
   * @see https://stackoverflow.com/questions/57664614
   */
  return data ? null : (
    <div
      className={[CSS.markAsReadButton, isMutating ? CSS.loading : ''].join(
        ' '
      )}
      onClick={() => !isMutating && trigger()}>
      {isMutating ? (
        <Vector name="loadingDots" className={CSS.loading} />
      ) : (
        <Vector
          name={isReadAll ? 'FiEye' : 'FaRegEnvelopeOpen'}
          title="پاک کردن همه"
          className={[error ? CSS.error : '', isReadAll ? CSS.icon : ''].join(
            ' '
          )}
          hasFocus
        />
      )}
    </div>
  );
}
